import { useState } from 'react'
import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle"
import TagReportItem from "../../components/editor/TagReportItem"

const TagReport = () => {

	const [reports] = useState([
		{
			label: 'Verb',
			color: '#FE595F',
			appearence: 37
		},
		{
			label: 'Noun',
			color: '#FFCA39',
			appearence: 21
		},
		{
			label: 'Preposition',
			color: '#8AC827',
			appearence: 15
		},
		{
			label: 'Adjective',
			color: '#1B82C4',
			appearence: 37
		},
		{
			label: 'Adverb',
			color: '#6A4C93',
			appearence: 21
		},
		{
			label: 'Pronoun',
			color: '#097E8B',
			appearence: 15
		},
		{
			label: 'Date',
			color: '#FF9E1D',
			appearence: 37
		},
		{
			label: 'Currency',
			color: '#2CC4B6',
			appearence: 21
		}
	])

	return (
		<div className='bg-white shadow-sm lg:p-9 2xl:p-10 flex flex-col overflow-hidden'>
			<EditorFeatureTitle title='Tag Report' />
			<div className='flex-1 scrollbar-y-2 pr-5 -mr-5 lg:mt-7 xl:mt-8 2xl:mt-9 lg:space-y-4 2xl:space-y-5'>
				{reports.map((report, i) => (
					<TagReportItem
						key={i}
						color={report.color}
						label={report.label}
						appearence={report.appearence}
					/>
				))}
			</div>
		</div>
	)
}

export default TagReport